<template>
	<div id="app-wrapper" class="c-site">
		<div class="o-container o-container--wide o-container-wide">
			<div id="app">
				<div class="c-site__body">
					<div class="c-site__body--compare layout layout--flush">
						<comparison :view-type="'energy'" :target-group="'Consumer'" v-if="!showingForm"></comparison>
						<register-form :target-group="'Consumer'"></register-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Comparison from '@/energy/components/Comparison';
import RegisterForm from '@/energy/components/RegisterForm';
import VueAnalytics from 'vue-analytics';

/* eslint-disable */
if (APP_GACODE) {
	/* eslint-disable */
	let gaCode = APP_GACODE;
	if (gaCode !== null) {
		Vue.use(VueAnalytics, {
			id: gaCode,
		});
	}
}
import Vue from 'vue';
import VTooltip from '@/../node_modules/v-tooltip/dist/v-tooltip.umd';
import TooltipConfig from '@/tooltip.config';

const isWebComponent = APP_TYPE === 'webcomponent';

Vue.use(VTooltip);
VTooltip.options = Object.assign(VTooltip.options, TooltipConfig);

import { baseMixin } from './tools';

Vue.mixin(baseMixin);

let clientHeaderString = APP_HEADER && APP_HEADER.length > 0 ? APP_HEADER + '.' : '';
const clientHeader = () => ({
	component: import(`@/energy/partials/layout/Header.${clientHeaderString}vue`),
});
export default {
	components: {
		clientHeader: clientHeader,
		Comparison: Comparison,
		RegisterForm: RegisterForm,
	},
	mounted: function () {
		window.addEventListener('popstate', (e) => {
			this.emit('hide-form', null);
			return;
		});
	},
	beforeMount() {},
	data: function () {
		return {
			clientHeaderString: clientHeaderString,
			currentClientHeader: '',
		};
	},
};
</script>

<style lang="scss">
@import '@/assets/styles/faux.scss';
</style>
